export const AnalyticsEvents = {
  // LANDING IBAN //
  iban_oplata_logo: "iban_oplata_logo",

  iban_oplata_contact_us: "iban_oplata_contact_us",
  iban_oplata_api_integration: "iban_oplata_api_integration",
  iban_oplata_tariffs: "iban_oplata_tariffs",
  iban_oplata_download_app: "iban_oplata_download_app",
  iban_oplata_download_app_ios: "iban_oplata_download_app_ios",
  iban_oplata_download_app_andr: "iban_oplata_download_app_andr",

  iban_oplata_faq_fopkasa_click: "iban_oplata_faq_fopkasa_click",

  iban_oplata_create_qr_url: "iban_oplata_create_qr_url",
  iban_oplata_copy_qr_url: "iban_oplata_copy_qr_url",
  iban_oplata_copy_info: "iban_oplata_copy_info",
  iban_oplata_copy_: "iban_oplata_copy_",
  iban_oplata_open_qr_url: "iban_oplata_open_qr_url",
  iban_oplata_create_another_qr_url: "iban_oplata_create_another_qr_url",
  iban_oplata_show_cabinet_modal: "iban_oplata_show_cabinet_modal",
  iban_oplata_close_cabinet_modal: "iban_oplata_close_cabinet_modal",
  iban_oplata_cabinet_modal_create: "iban_oplata_cabinet_modal_create",
  iban_oplata_show_limit_modal: "iban_oplata_show_limit_modal",
  iban_oplata_limit_modal_create_cabinet:
    "iban_oplata_limit_modal_create_cabinet",

  iban_oplata_try_for_free: "iban_oplata_try_for_free",
  iban_oplata_how_it_works_video_play: "iban_oplata_how_it_works_video_play",
  iban_oplata_video_play: "iban_oplata_video_play",
  iban_oplata_video_close: "iban_oplata_video_close",
  iban_oplata_bussiness_: "iban_oplata_bussiness_",
  iban_oplata_media_show_more: "iban_oplata_media_show_more",
  iban_oplata_media_read_article: "iban_oplata_media_read_article",
  iban_oplata_media_carousel_navigate: "iban_oplata_media_carousel_navigate",
  iban_oplata_blog_read_article: "iban_oplata_blog_read_article",

  footer_: "footer_",

  // IBAN QR //

  iban_qr_pay_modal_open: "iban_qr_pay_modal_open",
  iban_qr_pay_modal_copy: "iban_qr_pay_modal_copy",
  iban_qr_pay_modal_chrome: "iban_qr_pay_modal_chrome",
  iban_qr_pay_modal_close: "iban_qr_pay_modal_close",
  iban_qr_pay_default: "iban_qr_pay_default",
  iban_qr_pay_with_bank: "iban_qr_pay_with_bank",
  iban_qr_pay_: "iban_qr_pay_",
  iban_qr_try_iban_oplata: "iban_qr_try_iban_oplata",
  iban_qr_other_banks: "iban_qr_other_banks",

  iban_qr_show_qr_modal: "iban_qr_show_qr_modal",
  iban_qr_close_qr_modal: "iban_qr_close_qr_modal",

  iban_qr_logo_click: "iban_qr_logo_click",
  iban_qr_blog_click: "iban_qr_blog_click",
  iban_qr_blog_from_payment_click: "iban_qr_blog_from_payment_click",
  iban_qr_open_acc_info: "iban_qr_open_acc_info",
  iban_qr_close_acc_info: "iban_qr_close_acc_info",

  iban_subscription_: "iban_subscription_",
  iban_subscription_premium_custom: "iban_subscription_premium_custom",
  iban_subscription_modal_close: "iban_subscription_modal_close",
  iban_profile_btn_click: "iban_profile_btn_click",
  iban_profile_modal_close: "iban_profile_modal_close",
  iban_profile_modal_email: "iban_profile_modal_email",

  // AUTH //
  auth_google_btn_click: "auth_google_btn_click",
  auth_facebook_btn_click: "auth_facebook_btn_click",

  auth_forgot_password: "auth_forgot_password",

  auth_google: "auth_google",
  auth_facebook: "auth_facebook",

  auth_with_email: "auth_with_email",
  auth_check_email: "auth_check_email",

  // FORGOT PASSWORD //
  forgot_password_send_email: "forgot_password_send_email",
  forgot_password_go_back: "forgot_password_go_back",
  forgot_password_no_email_received: "forgot_password_no_email_received",

  // RESET PASSWORD //
  reset_password_save: "reset_password_save",

  // CABINET //

  // FEATURE ANNOUNCEMENT MODAL //
  feature_announcement_open: "feature_announcement_open",
  feature_announcement_video_play_img: "feature_announcement_video_play_img",
  feature_announcement_video_play_btn: "feature_announcement_video_play_btn",
  feature_announcement_video_close: "feature_announcement_video_close",
  feature_announcement_remind_later: "feature_announcement_remind_later",

  // MENUS //
  side_menu_: "side_menu_",
  user_menu_: "user_menu_",
  mobile_menu_: "mobile_menu_",

  side_menu_toggle: "side_menu_toggle",

  // HOME //
  home_create_invoice: "home_create_invoice",
  home_all_invoices: "home_all_invoices",

  new_year_choose_tariff: "new_year_choose_tariff",

  // INVOICES //
  invoices_create_invoice: "invoices_create_invoice",
  invoices_view_invoice_details: "invoices_view_invoice_details",
  copy_invoice: "copy_invoice",
  edit_invoice: "edit_invoice",
  dublicate_invoice: "dublicate_invoice",
  qrcode_invoice: "qrcode_invoice",
  delete_invoice: "delete_invoice",
  toggle_favorite_invoice: "toggle_favorite_invoice",

  qrcode_invoice_install_: "qrcode_invoice_install_",

  ibanCreated: "ibanCreated",
  cabinetIbanCreated: "cabinetIbanCreated",

  invoice_details_copy_url: "invoice_details_copy_url",
  invoice_details_qrcode: "invoice_details_qrcode",
  invoice_details_duplicate: "invoice_details_duplicate",
  invoice_details_edit: "invoice_details_edit",
  invoice_details_delete: "invoice_details_delete",

  invoice_details_tab_click: "invoice_details_tab_click",
  invoice_details_payment_status_change:
    "invoice_details_payment_status_change",

  // ACCOUNTS //
  accounts_create_account: "accounts_create_account",
  accounts_create_invoice: "accounts_create_invoice",
  accounts_edit_account: "accounts_edit_account",
  accounts_dublicate_account: "accounts_dublicate_account",
  accounts_delete_account: "accounts_delete_account",

  // API TOKEN //
  api_token_create_token: "api_token_create_token",
  api_token_regenerate_token: "api_token_regenerate_token",
  api_token_copy_token: "api_token_copy_token",
  api_token_delete_token: "api_token_delete_token",

  // SETTINGS //
  settings_update_exp_modal_open: "settings_update_exp_modal_open",
  settings_update_exp_modal_close: "settings_update_exp_modal_close",
  settings_update_exp_modal_confirm: "settings_update_exp_modal_confirm",
  settings_invoice_exp_updated: "settings_invoice_exp_updated",

  // PROFILE //
  profile_update_password: "profile_update_password",
  profile_delete_account: "profile_delete_account",
  profile_delete_account_confirm: "profile_delete_account_confirm",

  // SUBSCRIPTION //
  subscription_choose_plan_: "subscription_choose_plan_",
  subscription_choose_with_promocode: "subscription_choose_with_promocode",
  free_subscription_activated: "free_subscription_activated",
  subscription_cancel_subscription: "subscription_cancel_subscription",
  subscription_cancel_subscription_confirm:
    "subscription_cancel_subscription_confirm",

  subscription_use_promocode_btn: "subscription_use_promocode_btn",
  promocode_submit: "promocode_submit",
  promocode_close_modal: "promocode_close_modal",

  // SUPPORT //
  support_telegram: "support_telegram",
  support_viber: "support_viber",
  support_phone: "support_phone",

  // LOGOUT //
  logout: "logout",
};
